import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean;
}
export function Card({
  className = '',
  children,
  noPadding = false,
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm ${className}`} {...props} data-id="element-134">
      <div className={noPadding ? '' : 'p-6'} data-id="element-135">{children}</div>
    </div>;
}
export function CardHeader({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`flex flex-col space-y-1.5 p-6 pb-0 ${className}`} {...props} data-id="element-136">
      {children}
    </div>;
}
export function CardTitle({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={`font-semibold leading-none tracking-tight text-slate-900 ${className}`} {...props} data-id="element-137">
      {children}
    </h3>;
}
export function CardContent({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`p-6 pt-4 ${className}`} {...props} data-id="element-138">
      {children}
    </div>;
}